import { USER_TYPE } from 'app/ducks/auth/types'

// Seeded (off) by amsm-backend's
// hall/feature_flags/migrations/0010_seed_retention_module_flag.py.
export const RETENTION_MODULE_FLAG = 'retention_module'

// Collaborator and above — the same audience the backend enforces
// (`contracts.retention.assert_retention_module_access`).
export const RETENTION_ROLES = [
  USER_TYPE.COLLABORATOR,
  USER_TYPE.MANAGER,
  USER_TYPE.ADMINISTRATOR,
]

export const CANCELLATION_REPORT_PATH = '/contracts/cancellation-report'

// Identifier prefixes of the tasks that chase a contract renewal (see
// amsm-backend's management/models RENEWAL_TASK_PREFIXES)
export const RENEWAL_TASK_PREFIXES = [
  'expiring_contract_',
  'expired_contract_',
  'renewal_followup_',
]

export const isRenewalTask = (identifier) =>
  !!identifier &&
  RENEWAL_TASK_PREFIXES.some((prefix) => identifier.startsWith(prefix))

export const TASK_STATUS = {
  pending: { label: 'Pendente', color: '#2a78d6', icon: 'schedule' },
  in_progress: { label: 'Em andamento', color: '#eda100', icon: 'autorenew' },
  completed: { label: 'Concluída', color: '#1baf7a', icon: 'check_circle' },
  cancelled: { label: 'Cancelada', color: '#9a9a94', icon: 'cancel' },
  expired: { label: 'Expirada', color: '#e34948', icon: 'event_busy' },
}

export const CONTACT_CHANNELS = [
  { value: 'in_person', label: 'Presencial' },
  { value: 'phone', label: 'Telefone' },
  { value: 'whatsapp', label: 'WhatsApp' },
  { value: 'email', label: 'E-mail' },
  { value: 'sms', label: 'SMS' },
]
